import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initPartnerSchoolsStrip() {
  Alpine.data(
    'partnerSchoolsStrip',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.partnerSchoolsStrip__swiper');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        const { size } = domEl.dataset;
        const slideSize = Math.min(Number(size), 7);
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .partnerSchoolsStrip__next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .partnerSchoolsStrip__prev`,
          },
          spaceBetween: 30,
          slidesPerView: 2.5,
          breakpoints: {
            640: {
              loop: slideSize > 3,
              centerInsufficientSlides: slideSize < 3,
              slidesPerView: 3,
              spaceBetween: 30,
            },
            768: {
              loop: slideSize > 5,
              centerInsufficientSlides: slideSize < 5,
              slidesPerView: 5,
              spaceBetween: 30,
            },
            1024: {
              loop: slideSize > 7,
              centerInsufficientSlides: slideSize < 7,
              slidesPerView: 7,
              spaceBetween: 40,
              autoplay: {},
            },
          },
        });
      },
    }),
  );
}
